import React from 'react';
import { Sun, Heart, Target, Scale, Smile } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Slider } from '../components/ui/slider';
import { TodoList } from './TodoList';

export const MorningIntention = ({ data, onUpdate }) => {
  const feelingEmojis = ['😫', '😔', '😐', '🙂', '😊', '😄', '🤩', '💪', '🔥', '⚡'];

  return (
    <div className="space-y-6" data-testid="morning-intention-section">
      {/* Wake Up Time */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-amber-400/20 flex items-center justify-center">
            <Sun className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">Wake Up Time</h3>
            <p className="text-xs text-white/50">When did you rise today?</p>
          </div>
        </div>
        <Input
          type="time"
          value={data.wakeUpTime || ''}
          onChange={(e) => onUpdate({ wakeUpTime: e.target.value })}
          className="input-futuristic font-mono text-xl"
          data-testid="wake-up-time-input"
        />
      </div>

      {/* Gratitude */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-rose-400/20 flex items-center justify-center">
            <Heart className="w-5 h-5 text-rose-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">What are you grateful for?</h3>
            <p className="text-xs text-white/50">Start your day with gratitude</p>
          </div>
        </div>
        <Textarea
          value={data.gratitude || ''}
          onChange={(e) => onUpdate({ gratitude: e.target.value })}
          placeholder="I'm grateful for..."
          className="input-futuristic min-h-24 resize-none"
          data-testid="gratitude-input"
        />
      </div>

      {/* What Will Make Today Great */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-cyan-400/20 flex items-center justify-center">
            <Target className="w-5 h-5 text-cyan-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">What will make today great?</h3>
            <p className="text-xs text-white/50">Set your daily intention</p>
          </div>
        </div>
        <Textarea
          value={data.whatWillMakeTodayGreat || ''}
          onChange={(e) => onUpdate({ whatWillMakeTodayGreat: e.target.value })}
          placeholder="Today will be great because..."
          className="input-futuristic min-h-24 resize-none"
          data-testid="today-great-input"
        />
      </div>

      {/* Stats: Weight & Feeling */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Weight */}
        <div className="glass-card p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-lime-400/20 flex items-center justify-center">
              <Scale className="w-5 h-5 text-lime-400" />
            </div>
            <div>
              <h3 className="font-semibold text-white">Weight</h3>
              <p className="text-xs text-white/50">Optional tracking</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Input
              type="number"
              value={data.weight || ''}
              onChange={(e) => onUpdate({ weight: e.target.value })}
              placeholder="0"
              className="input-futuristic font-mono text-2xl text-center"
              data-testid="weight-input"
            />
            <span className="text-white/50 text-sm">lbs</span>
          </div>
        </div>

        {/* Feeling */}
        <div className="glass-card p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-purple-500/20 flex items-center justify-center">
              <Smile className="w-5 h-5 text-purple-400" />
            </div>
            <div>
              <h3 className="font-semibold text-white">How are you feeling?</h3>
              <p className="text-xs text-white/50">Rate 1-10</p>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-4xl">{feelingEmojis[(data.feeling || 5) - 1]}</span>
              <span className="font-mono text-3xl text-purple-400">{data.feeling || 5}</span>
            </div>
            <Slider
              value={[data.feeling || 5]}
              onValueChange={([value]) => onUpdate({ feeling: value })}
              min={1}
              max={10}
              step={1}
              className="py-2"
              data-testid="feeling-slider"
            />
          </div>
        </div>
      </div>

      {/* To-Do List */}
      <TodoList
        todos={data.todos || []}
        priorityTodos={data.priorityTodos || []}
        onUpdate={(todoData) => onUpdate(todoData)}
      />
    </div>
  );
};

export default MorningIntention;
